export const loopNp = (items) => {
    let bdg = [];
    for (const key in items) {
        if (Object.hasOwnProperty.call(items, key)) {
            const element = items[key];

            if (element.not) {
                bdg.push(
                    <span
                        key={element.it}
                        className={
                            ' bg-indigo-100 text-indigo-800 text-9 sm:text-xs font-semibold text-center w-4 sm:w-6  mr-1 rounded dark:bg-indigo-200 dark:text-indigo-900 '
                        }>
                        {element.it}
                    </span>
                );
            } else {
                bdg.push(
                    <span
                        key={element.it}
                        className="bg-red-100 text-red-800 text-9 sm:text-xs font-semibold text-center w-4 sm:w-6 mr-1 rounded dark:bg-red-200 dark:text-red-900">
                        {element.it}
                    </span>
                );
            }
        }
    }
    return bdg;
};
export const daysBA = () => {
    let bdg = [];
    for (let i = 1; i <= 25; i++) {
        bdg.push(
            <option value={i} key={i}>
                {i} Dias Despues
            </option>
        );
    }
    for (let i = 1; i <= 25; i++) {
        bdg.push(
            <option value={-i} key={-i}>
                {i} Dias Antes
            </option>
        );
    }
    return bdg;
};

export const getSelProp = (items, name = 'nodo') => {
    let rou = [{ value: 0, label: 'Todos' }];
    for (const key in items) {
        if (Object.hasOwnProperty.call(items, key)) {
            const e = items[key];
            rou.push({ value: e.id, label: e[name] });
        }
    }
    return rou;
};
export const getEmiCl = (items, name = 'nombre') => {
    let rou = [{ value: '', label: 'Ninguno' }];
    for (const key in items) {
        if (Object.hasOwnProperty.call(items, key)) {
            const e = items[key];
            rou.push({ value: e.id, label: e[name] });
        }
    }
    return rou;
};

export const bytesToSize = (bytes) => {
    const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PT'];

    if (bytes === 0) return '0 Byte';

    const i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)), 10);
    return `${Math.round(bytes / Math.pow(1024, i), 2)} ${sizes[i]}`;
};
export const oppSelect = ( array, key ) => {
    let Opp = [];

    for (let i = 0; i < array.length; i++) {
        const el = array[i];
        Opp.push({ value: el.id, label: el[key] });
    }
    return Opp;
};
